export default "__VITE_ASSET__itVpLhsY__"